<template>
  <div class="px-20px border-t-2 border-gray-200 bg-white py-2.5">
    <div class="flex items-center justify-end gap-2">
      <a :href="link"><slot /></a>
      <DownloadIcon class="w-4" />
    </div>
  </div>
</template>

<script>
import { isObject } from "../../../compostables/useHelpers";
import DownloadIcon from "../../Svgs/Icons/DownloadIcon.vue";

export default {
  components: {
    DownloadIcon,
  },

  props: {
    link: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    // if( isObject(props.data) ) {
    //   const link =
    // }
  },
};
</script>
